/**
 * @documental
 * @export Placeholder
 * @name
 * LoadingGroup.Placeholder
 */

import { FC, ReactNode, PropsWithChildren } from "react";
import { useLoading } from "./useLoading";

/**
 * The `Placeholder` component properties.
 */
export interface PlaceholderProps {

  /**
   * The fallback content to display if loading.
   */
  readonly fallback: ReactNode;
}

/**
 * A component which renders fallback content instead of its children if loading.
*/
export const Placeholder: FC<PropsWithChildren<PlaceholderProps>> = (props) => {
  const { fallback, children } = props;
  const loading = useLoading();

  if (loading) {
    return (
      <div aria-live="polite" aria-busy="true">
        {fallback}
      </div>
    );
  } else {
    return <>{children}</>;
  }
};
